import FormattedMessage from 'I18n/components/FormattedMessage';
import Carousel from './Carousel';
import SectionHeading from './SectionHeading';
// @ts-expect-error Library not yet migrated
import useMediaQuery from '../hooks/useMediaQuery';
import { device } from '../constants/StyledComponentConstants';
import ACInstructorCard from 'academy-common-lib/components/card/ACInstructorCard';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InstructorList = ({
  handleOrganisationUrlClick,
  language,
  padding,
  paddingBlock,
  professors
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-raised",
    marginBlockStart: "0",
    padding: padding,
    paddingBlock: paddingBlock,
    children: /*#__PURE__*/_jsxs(View, {
      paddingInline: isMobile ? '300' : '0',
      children: [/*#__PURE__*/_jsx(SectionHeading, {
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyComponents.instructorList.heading"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: isMobile || professors.length < 2 ? /*#__PURE__*/_jsx("div", {
          children: professors.map(professor => /*#__PURE__*/_jsx(ACInstructorCard, {
            description: professor.descriptions[language.toLowerCase()],
            imageUrl: professor.image,
            jobTitle: professor.jobTitle,
            maxInlineSize: !isMobile && professors.length ? 'calc(min(850px, 100vw) * 0.8)' : undefined,
            name: professor.name,
            onClick: handleOrganisationUrlClick(professor.id.toString(), professor.organisation, professor.organisationUrl),
            organisationName: professor.organisation,
            organisationUrl: professor.organisationUrl
          }, professor.id))
        }) : /*#__PURE__*/_jsx(Carousel, {
          fixedMargin: true,
          pageMargin: isMobile ? '300' : '800',
          children: professors.map(professor => /*#__PURE__*/_jsx(ACInstructorCard, {
            description: professor.descriptions[language.toLowerCase()],
            imageUrl: professor.image,
            jobTitle: professor.jobTitle,
            maxInlineSize: !isMobile && professors.length ? 'calc(min(850px, 100vw) * 0.8)' : undefined,
            name: professor.name,
            onClick: handleOrganisationUrlClick(professor.id.toString(), professor.organisation, professor.organisationUrl),
            organisationName: professor.organisation,
            organisationUrl: professor.organisationUrl
          }, professor.id))
        })
      })]
    })
  });
};
export default InstructorList;